module.exports = __webpack_public_path__ + "3b8b2a803b97c3efaa9fc0f48d1f8da8.svg";